import { getStore } from "~/app/store/getStore";
import { beginSessionExpiration } from "~/features/auth/session/beginSessionExpiration";

/** Shows the expiry UI immediately and logs out without reloading. */
export function triggerSessionExpired(): void {
  const store = getStore();
  if (store.getState().sessionExpiration.phase !== "active") {
    return;
  }

  void beginSessionExpiration(store.dispatch);
}
